import React, { useEffect, useState } from "react";
import { createSubCategory } from "../../redux/actions/subcategoryAction";
import { useSelector, useDispatch } from "react-redux";
import notify from "../../hook/useNotifaction";
import { getAllCategory } from "../../redux/actions/categoryAction";
import { validateNameSubCatgory } from "../../Feature/NameSubCatgoryValidRegex";

const AddSubcategoryhook = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (!navigator.onLine) {
      notify("هناك مشكله فى الاتصال بالانترنت", "warn");
      return;
    }
    dispatch(getAllCategory());
  }, [dispatch]);
  const [id, setID] = useState("0");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(true);
  //get last catgeory state from redux
  const category = useSelector((state) => state.allCategory.category);

  //get last sub catgeory state from redux
  const subcategory = useSelector((state) => state.subCategory.subcategory);
  //on change dropdown menu
  const handelChange = (e) => {
    // console.log(e.target.value);
    setID(e.target.value);
  };

  //to save name
  const onChangeName = (e) => {
    e.persist();
    setName(e.target.value);
  };
  const isComplate = id !== "0" && validateNameSubCatgory(name).length === 0;

  //on save data
  const handelSubmit = async (e) => {
    e.preventDefault();
    if (!navigator.onLine) {
      notify("هناك مشكله فى الاتصال بالانترنت", "warn");
      return;
    }
    if (id === "0") {
      notify("من فضلك اختر تصنيف رئيسي", "warn");
      return;
    }
    if (name === "") {
      notify("من فضلك ادخل اسم التصنيف", "warn");
      return;
    }

    setLoading(true);
    await dispatch(
      createSubCategory({
        name,
        mainCategory: id,
      })
    );
    setLoading(false);
  };
  useEffect(() => {
    if (loading === false) {
      setName("");
      setID("0");
      //   if (subcategory)
      if (subcategory.status === 201 || subcategory.status === 200) {
        notify("تمت الاضافة بنجاح", "success");
      } else if (
        subcategory === "Error Error: Request failed with status code 400"
      ) {
        notify("هذا الاسم مكرر من فضلك اختر اسم اخر", "warn");
      } else if (
        subcategory === "Error Error: Request failed with status code 500"
      ) {
        notify("هذا الاسم مكرر من فضلك اختر اسم اخر", "warn");
      } else {
        notify("هناك مشكله فى عملية الاضافة", "warn");
      }

      setLoading(true);
    }
  }, [loading, subcategory]);

  return [
    id,
    name,
    loading,
    category,
    subcategory,
    handelChange,
    handelSubmit,
    onChangeName,
    isComplate,
  ];
};

export default AddSubcategoryhook;
